import { useSession } from "@/lib/auth/auth";
import { SystemRole, getUserAccountingFirmRole } from "@/lib/users/user-roles";
import { useMemo } from "react";

export const usePermissions = () => {
  const { data: sessionData, isPending } = useSession();
  const isSuperAdmin = useMemo(() => {
    return sessionData?.user?.systemRole === SystemRole.SUPER_ADMIN;
  }, [sessionData?.user]);

  const isAccountingFirmAdmin = useMemo(() => {
    return (
      sessionData?.user &&
      getUserAccountingFirmRole(sessionData?.user) === "admin"
    );
  }, [sessionData?.user]);

  const result = useMemo(() => {
    return {
      isSuperAdmin,
      isAccountingFirmAdmin,
      requiresOcrReview: false,
      isLoading: isPending,
    };
  }, [isSuperAdmin, isAccountingFirmAdmin, isPending]);

  return result;
};
